<script>
const FALLBACK_SUBTITLES = [
  'Was kann ich heute für Dich tun?',
  'Deine persönliche HR-Assistentin.',
  'Wie kann ich Dir helfen?',
  'Frag mich \u2014 ich bin für Dich da.',
  'HR-Trends, Speaker, Sessions \u2014 frag mich!',
]
const FALLBACK_PLACEHOLDERS = [
  'Welche Sessions gibt es zum Thema KI?',
  'Wer sind die Speaker zum Thema Leadership?',
  'Welche Aussteller bieten Recruiting-Lösungen?',
  'Gibt es Vorträge zu New Work?',
  'Welche Keynotes sollte ich nicht verpassen?',
]

function pick(a) { return a[Math.floor(Math.random() * a.length)] }

export default {
  name: 'HrmineWelcome',
  props: {
    firstName: {
      type: String,
      default: ''
    },
    hints: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const ph = this.hints.placeholders || []
    const st = this.hints.subtitles || []
    return {
      input: '',
      subtitle: st.length ? pick(st) : pick(FALLBACK_SUBTITLES),
      placeholder: ph.length ? pick(ph) : pick(FALLBACK_PLACEHOLDERS),
      suggestions: (ph.length ? ph : FALLBACK_PLACEHOLDERS).slice(0, 3)
    }
  },
  computed: {
    greeting() {
      const h = new Date().getHours()
      const formal = h < 12 ? 'Guten Morgen' : h < 18 ? 'Guten Tag' : 'Guten Abend'
      const greetings = [formal, formal, 'Hallo', 'Hi', 'Hey', 'Moin', 'Servus', 'Na']
      return greetings[Math.floor(Math.random() * greetings.length)]
    }
  },
  watch: {
    hints(h) {
      if (h.subtitles && h.subtitles.length) this.subtitle = pick(h.subtitles)
      if (h.placeholders && h.placeholders.length) {
        this.placeholder = pick(h.placeholders)
        this.suggestions = h.placeholders.slice(0, 3)
      }
    }
  },
  methods: {
    submit() {
      const q = this.input.trim()
      if (!q) return
      this.$router.push({ path: '/ai-chat', query: { search: q } })
    },
    adoptPlaceholder() {
      if (!this.input) {
        this.input = this.placeholder
        this.$nextTick(() => this.$el.querySelector('input').select())
      }
    }
  }
}
</script>

<template>
  <div class="card mb-3" v-if="firstName">
    <div class="card-body">
      <h5 class="card-title">
        <i class="bi bi-chat-dots text-primary me-2"></i>
        {{ greeting }} {{ firstName }}, ich bin <b>HRmine</b>, Deine KI-Assistentin
      </h5>
      <p class="text-muted mb-2">{{ subtitle }}</p>
      <div class="input-group">
        <input v-model="input" @keyup.enter="submit" @focus="adoptPlaceholder"
               type="text" class="form-control" :placeholder="placeholder" maxlength="500">
        <button @click="submit" class="btn btn-primary" :disabled="!input.trim()">
          <i class="bi bi-send"></i>
        </button>
      </div>
      <div v-if="suggestions.length && !input" class="d-flex flex-wrap gap-1 mt-2">
        <button v-for="s in suggestions" :key="s" @click="input = s"
                class="btn btn-outline-secondary btn-sm rounded-pill"
                style="font-size:.75rem" type="button">{{ s }}</button>
      </div>
    </div>
  </div>
</template>
